import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const sliderSlice = createSlice({
  name: "slider",
  initialState: {
    sliderData: [],
    isLoading: false,
    isError: false,
  },

  reducers: {
    fetchSliderStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchSliderSuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.sliderData = action.payload;
    },
    fetchSliderFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const {
  fetchSliderStart,
  fetchSliderSuccess,
  fetchSliderFailure,
} = sliderSlice.actions;

export const fetchSlider = () => async (dispatch) => {
  try {
    dispatch(fetchSliderStart());
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchSliderSuccess(response.data.banners));
  } catch (error) {
    dispatch(fetchSliderFailure());
  }
};

export default sliderSlice.reducer;
